<template>
  <div>
    <!-- Loader -->
    <portal to="loaderTarget">
      <div class="absolute bg-grey-100 bg-opacity-50 h-full left-0 top-0 w-full z-99" v-if="isLoading">
        <gd-loader :label="$t('frontend_loading')"/>
      </div>
    </portal>
    
  <div class="flex flex-col w-full bg-white rounded p-4">
    <div class="flex flex-col w-1/2 mb-2">
      <h4 class="font-semibold text-grey-700">
        {{ $t('frontend_groovemail_contacts_step1_upload_contacts') }}
      </h4>
    </div>
    <div class="flex flex-col w-1/2 mb-2">
      <span class="text-sm text-grey-700"
        >
        {{ $t('frontend_groovemail_contacts_step1_upload_your_leads') }}
        </span
      >
    </div>
    <div class="flex flex-col mb-2 border-grey-100 border -mx-4 px-4">
      <gd-tabs
        :tabs="contact_tabs"
        :currentTab="localModel.upload_tab"
        :wrapper-class="'pt-4 px-0 gs-default-tabs'"
        :tab-class="'pb-4 mr-4 gs-default-tabs-item'"
        :tab-active-class="
          'border-primary border-b-2 text-primary gs-default-tabs-item-active'
        "
        :line-class="'gs-default-tabs-active-line'"
        @onClick="handleTabChange2"
        :key="this.$t('frontend_groovemail_contact_tabs_step1_import')"
      />
      <!-- <div class="flex bg-dark p-4"> -->
      <!-- <div class="bg-white w-full"> -->
      <div v-if="localModel.upload_tab === 'import'">
        <div class="flex">
          <div class="w-full p-4">
            <div class="flex flex-row w-1/2 mb-6 float-left text-left">
              <label
              class="font-semibold text-sm text-grey-700 mb-2 mr-2"
              >
              {{ $t('frontend_groovemail_contacts_step1_file_has') }}
              </label
              >
              <gd-toggle
                bgClass="bg-grey-300"
                :value="localModel.has_headers"
                @change="HasHeaders"
              /></div>

            <div class="flex flex-row justify-end w-1/2 mb-6">
              <label
                class="font-semibold text-sm text-grey-700 mb-2 mr-2"
                >
                {{ $t('frontend_groovemail_contacts_step1_update') }}
                </label
              >
              <gd-toggle
                bgClass="bg-grey-300"
                :value="localModel.is_overwrite"
                @change="overWriteContactDetails"
              />
            </div>

            <vue-dropzone
              ref="myVueDropzone"
              id="dropzone"
              :options="dropzoneOptions"
              @vdropzone-success="vsuccess"
              @vdropzone-sending="sendingEvent"
            ></vue-dropzone>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="flex mb-4 pt-4">
          <div class="w-full">
            <div class="flex mb-4">
              <div class="w-full text-center p-2">
                <text-area
                  class="h-32"
                  variant="base"
                  v-model="localModel.upload_contacts_data"
                  :placeholder="$t('frontend_groovemail_add_contact_seperated_by_line')"
                ></text-area>
                <!-- <div class="float-right mr-4 mt-4">
                  <gd-button
                    variant="primary"
                    @click="uploadcontacts"
                    class="w-40 mr-4"
                    >Upload</gd-button
                  > -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- </div> -->
      <!-- </div> -->
    </div>
  </div>
</template>
<script>

import Swal from 'sweetalert2';
import themeConfig from '@/theme/themeConfig.js';
import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import Contact from '@/models/Contact';
import {
  required,
  minLength,
  maxLength,
  email
} from 'vuelidate/lib/validators';
export default {
  name: 'step1',
  props: {
    model: {
      required: true
    }
  },
  data() {
    return {
      localModel: this.model,
      fullPageLoader: true,
      isLoading: false,
      loaderColor: themeConfig.appPrimaryColor,
      contact_tabs: [
        {
          title: this.$t('frontend_groovemail_contact_tabs_step1_import'),
          value: 'import'
        },
        {
          title: this.$t('frontend_groovemail_contact_tabs_step1_manually'),
          value: 'manually'
        }
      ],
      dropzoneOptions: {
        url: window.config.apiUrl + '/import/csv',
        paramName: 'file',
        //addRemoveLinks: true,
        headers: {
          //"Content-type":"multipart/form-data; charset=utf-8; boundary=" + Math.random().toString().substr(2),
          'Authorization': 'Bearer '+JSON.parse(localStorage.getItem('user')).token,
          /*'Content-type' : 'multipart/form-data',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Methods': 'GET, POST, PUT, DELETE, OPTIONS',
          'Cache-Control': null,
          'X-Requested-With': null*/
        }
      }
    };
  },
  validations: {
    localModel: {
    }
  },
  methods: {
    validate() {
    	if(this.localModel.upload_tab === 'manually' && this.localModel.upload_contacts_data!=''){
    		var isValid = true;
    	} else if(this.localModel.upload_tab === 'import' && this.localModel.created_contacts!=''){
    		var isValid = true;
    	} else {
    		var isValid = false;
    	}

      this.$emit('on-validate', isValid);
      return isValid;
    },
    handleTabChange2(newTab) {
      this.localModel.upload_tab = newTab;
    },
    HasHeaders() {
      this.localModel.has_headers = !this.localModel.has_headers;
    },
    overWriteContactDetails() {
      this.localModel.is_overwrite = !this.localModel.is_overwrite;
    },
    vsuccess(file, response) {
      this.localModel.created_contacts = response.records;
      this.localModel.totalfields = response.records[0].length;
      this.localModel.importid = response.importid;
      this.localModel.matchfields = [];
    },
    sendingEvent(file, xhr, formData) {
      formData.append('has_headers', this.localModel.has_headers);
      formData.append('file', file);
    },

    showLoader() {
      if (!this.isLoading) {
        this.isLoading = true;
      }
    },

    hideLoader() {
      if (this.isLoading) {
        this.isLoading = false;
      }
    },

  },
  components: {
    vueDropzone: vue2Dropzone
  },
  computed: {},
  watch: {
    localModel() {
      this.$emit('updateModel', this.localModel);
    }
  }
};
</script>

